import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import AddUpdModal from './AddUpdModal'
import GeofenceModal from './GeofenceModal'
import { resourcesBranch, activeBranch, duplicateBranch } from '../../../helpers/backend_helper';
import { DestroyAlertHelper, Alert, ToastHelper } from '../../../helpers/alerts/alertHelper';
import { Container } from "reactstrap";
import { getStorageUser } from '../../../helpers/api_helper';
import ButtonHelper from '../../../helpers/ButtonHelper';
import UnitsModal from "./UnitsModal";
import RouteModal from "./RouteModal";

const BranchLines = () => {
    const authUser = getStorageUser();
    const [pending, setPending] = useState(false);
    const [modalGeo, setModalGeo] = useState({ show: false, id: null });
    const [modalRoute, setModalRoute] = useState({ show: false, id: null });
    const [modalUnits, setModalUnits] = useState({ show: false, id: null, route_id: null })
    const [modal, setModal] = useState({ show: false, update: false });
    const [dataPag, setDataPag] = useState({ total: 0 });
    const [filters, setFilters] = useState({ page: 1, perPage: 20, search: '', orderBy: 'id', order: 'asc', companySession: authUser.company_id });
    const [items, setItems] = useState([]);
    const itemBase = {
        id: null,
        name: '',
        route_id: authUser.route_id,
        route: null,
        cost: null,
        active: true,
        activeSelect: { label: 'Si', value: true },
        return_price: 0.00,
        frecuencia: null,
        geofence_route_id: '',
    }
    const [item, setItem] = useState(itemBase);

    const dispatch = useDispatch()
    useEffect(() => {
        let params = { params: filters }
        setPending(true)
        resourcesBranch('get', params).then(response => {
            setItems(response.data)
            setDataPag(response.meta)
            setPending(false)
        }
        )
    }, [filters])

    const addUpd = (row = false) => {
        if (row.id) {
            setItem(row)
            setModal({ ...modal, show: true, update: true })
        } else {
            setItem(itemBase)
            setModal({ ...modal, show: true, update: false })
        }
    }

    const destroy = async (id) => {
        DestroyAlertHelper(async confirmed => {
            if (!confirmed) { return; }
            const response = await resourcesBranch('del', id, id);
            Alert(response.message, response.status)
            if (response.status) {
                setItems(items.filter(i => i.id != id));
            }
        });
    }
    const active = (row) => {
        activeBranch(row).then(response => {
            if (response.status) {
                let newItem = response.branch;
                let array = items.map(item => item.id !== newItem.id ? item : newItem);
                setItems(array);
            }
        })
    }
    const columns = Columns(addUpd, destroy, active, items, setItems, duplicateBranch, setModalGeo, modalGeo, authUser, setModalUnits, modalRoute, setModalRoute);
    document.title = "Ramales | Sistema de Logística";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper tittle="Ramales" columns={columns} items={items} pending={pending} config={dataPag} filters={filters} setFilters={setFilters} filterInp={false} >
                            <div className="col align-self-end">
                                <ButtonHelper
                                    addButon={authUser.can.branch_geo.create ? true : false}
                                    reportButons={false}
                                    actionReportButon={false}
                                    actionAddButon={authUser.can.branch_geo.create ? addUpd : false}
                                />
                            </div>
                        </DataTableHelper>
                    </div>
                </Container>
                {modal.show &&
                    <AddUpdModal
                        modal={modal}
                        setModal={setModal}
                        items={items}
                        setItems={setItems}
                        item={item}
                        setItem={setItem}
                    />
                }
                {modalGeo.show &&
                    <GeofenceModal
                        modal={modalGeo}
                        setModal={setModalGeo}
                    />
                }
                {modalUnits.show &&
                    <UnitsModal
                        modal={modalUnits}
                        setModal={setModalUnits}
                    />
                }

                {modalRoute.show &&
                    <RouteModal
                        modal={modalRoute}
                        setModal={setModalRoute}
                    />
                }
            </div>
        </React.Fragment>
    );
};

export default BranchLines;